import { render, staticRenderFns } from "./online_products.vue?vue&type=template&id=ebe4647e&scoped=true"
import script from "./online_products.vue?vue&type=script&lang=js"
export * from "./online_products.vue?vue&type=script&lang=js"
import style0 from "./online_products.vue?vue&type=style&index=0&id=ebe4647e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebe4647e",
  null
  
)

export default component.exports